module.exports = __webpack_public_path__ + "img/default-user-ben.a540ec95.png";